import { useAppSelector } from "@hooks/redux";
import { isDevelopmentOrStaging } from "@utils/env";

export const FREE_CHARACTER_LIMIT = 1;

interface UseAuthCreateCharactersResult {
  canCreateCharacter: boolean;
}

export const useAuthCreateCharacters = (existingCount: number): UseAuthCreateCharactersResult => {
  const membership = useAppSelector((state) => state.globalReducer.membership);
  const isFreeUser = !membership || membership.level === "Trial" || !!membership.expired;
  const forbiddenCreate = isFreeUser && existingCount >= FREE_CHARACTER_LIMIT;

  if (isDevelopmentOrStaging()) {
    return { canCreateCharacter: true };
  }

  return {
    canCreateCharacter: !forbiddenCreate,
  };
};
